import modelborder from '@/assets/images/index/modelborder.png';
import payfaile from '@/assets/images/order/payfaile.png';
import paySuccess from '@/assets/images/order/paySuccess.png';
import { getLocaleText } from '@/utils/utils';
import { width } from '@material-ui/system';
import { Modal, Toast } from 'antd-mobile';
import { useEffect, useRef, useState } from 'react';
import { history } from 'umi';

const OrderModel = (props: any) => {
  const { errorText, close } = props;

  const [countdownSeconds, setCountdownSeconds] = useState(5);
  const [isActive, setIsActive] = useState(true);

  const onWrapTouchStart = (e: any) => {
    // fix touch to scroll background page on iOS
    if (!/iPhone|iPod|iPad/i.test(navigator.userAgent)) {
      return;
    }
    const pNode = closest(e.target, '.am-modal-content');
    if (!pNode) {
      e.preventDefault();
    }
  };
  useEffect(() => {
    let intervalId: any;
    if (isActive && countdownSeconds > 0 && errorText == 200) {
      intervalId = setInterval(() => {
        setCountdownSeconds((prevSeconds) => prevSeconds - 1);
      }, 1000);
    } else if (isActive && countdownSeconds === 0) {
      setIsActive(false);
      history.push('/home');
    }

    return () => clearInterval(intervalId);
  }, [isActive, countdownSeconds, errorText]);
  return (
    <Modal
      style={{
        width: '5.2rem',
        background: 'RGBA(50, 39, 67, 1)',
        maxHeight: '90vh',
      }}
      visible={true}
      transparent
      maskClosable={false}
      // onClose={onClose}
      // title="Title"
      // footer={[{ text: 'Ok', onPress: () => { onClose() } }]}
      wrapProps={{ onTouchStart: onWrapTouchStart }}
    >
      {errorText === 200 ? (
        <div
          style={{
            padding: '0.32rem 0.38rem 0.35rem',
            color: '#f5f5f5',
            fontWeight: '100',
            maxHeight: '80vh',
          }}
        >
          <div
            style={{
              fontSize: '0.26rem',
              textAlign: 'left',
              paddingBottom: '0.32rem',
              fontWeight: '100',
            }}
          >
            <img
              src={paySuccess}
              alt=""
              style={{ width: '0.28rem', height: '0.28rem' }}
            />
            <span> {getLocaleText('order.page.paySuccess')}</span>
          </div>
          <div
            style={{
              whiteSpace: 'pre-line',
              textAlign: 'left',
              maxHeight: '20vh',
              overflow: 'auto ',
              marginBottom: '0.2rem',
            }}
          >
            {getLocaleText('order.page.paySuccess1')}
          </div>
          <div
            style={{
              whiteSpace: 'pre-line',
              textAlign: 'left',
              maxHeight: '20vh',
              overflow: 'auto ',
            }}
          >
            {getLocaleText('order.page.paySuccess2')},<br />
            {getLocaleText('order.page.paySuccess3')}
          </div>
          <div
            style={{
              margin: 'auto',
              marginTop: '0.24rem',
              height: '0.5rem',
              lineHeight: '0.5rem',
              display: 'flex',
              // width:'60%',
            }}
          >
            <div
              onClick={() => history.push('/home')}
              style={{
                marginTop: '0.24rem',
                flex: 1,
                background: 'url(' + modelborder + ') no-repeat center',
                backgroundSize: '120px 0.5rem',
                height: '0.5rem',
                lineHeight: '0.5rem',
                cursor: 'pointer',
              }}
            >
              <span style={{}}>{getLocaleText('login.page.sure')}</span>
            </div>
            <div style={{ flex: 1, float: 'left', marginTop: '0.24rem' }}>
              {countdownSeconds}s {getLocaleText('order.page.selfRecovery')}
            </div>
          </div>
        </div>
      ) : (
        <div
          style={{
            padding: '0.32rem 0.38rem 0.35rem',
            color: '#f5f5f5',
            fontWeight: '100',
            maxHeight: '80vh',
          }}
        >
          <div
            style={{
              fontSize: '0.26rem',
              textAlign: 'left',
              paddingBottom: '0.32rem',
              fontWeight: '100',
            }}
          >
            <img
              src={payfaile}
              alt=""
              style={{ width: '0.28rem', height: '0.28rem' }}
            />
            <span> {getLocaleText('order.page.payfaile1')}</span>
          </div>
          {errorText == 3006 || errorText == 3005 ? (
            <></>
          ) : (
            <div
              style={{
                whiteSpace: 'pre-line',
                textAlign: 'left',
                maxHeight: '20vh',
                overflow: 'auto ',
                marginBottom: '0.2rem',
              }}
            >
              {errorText
                ? `${getLocaleText('order.page.payfaile1')}(${errorText})`
                : `${getLocaleText('order.page.payfaile1')}`}
            </div>
          )}
          <div
            style={{
              whiteSpace: 'pre-line',
              textAlign: 'left',
              maxHeight: '20vh',
              overflow: 'auto ',
            }}
          >
            {errorText == 3005 ? (
              <>{getLocaleText('order.page.payfaile3005')}</>
            ) : errorText == 3006 ? (
              <>{getLocaleText('order.page.payfaile3006')}</>
            ) : (
              <>
                {getLocaleText('order.page.payfaile3')}
                <br />
                {getLocaleText('order.page.payfaile4')}
              </>
            )}
          </div>

          <div
            onClick={() => close()}
            style={{
              marginTop: '0.24rem',
              background: 'url(' + modelborder + ') no-repeat center',
              backgroundSize: '120px 0.5rem',
              height: '0.5rem',
              lineHeight: '0.5rem',
              cursor: 'pointer',
            }}
          >
            <span style={{}}>{getLocaleText('order.page.close')}</span>
          </div>
        </div>
      )}
    </Modal>
  );
};

export default OrderModel;
